import { render, staticRenderFns } from "./DeliveryServiceView.vue?vue&type=template&id=59228a23&"
import script from "./DeliveryServiceView.vue?vue&type=script&lang=js&"
export * from "./DeliveryServiceView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryServiceView.vue?vue&type=style&index=0&id=59228a23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports